 <template>
  <div class="container login">
    <div class="row mr-t-40 mb-4">
      <div class="col-12">
        <label class="payment-pin-label sign-in-label font-60"
          >Admin Sign In</label
        >
      </div>
    </div>

    <div class="row mr-t-40">
      <div class="col-2"></div>
      <div class="col-8">
        <div class="input-group rel-input-group icon-padding">
          <span class="align-self-center">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="25"
              height="25"
              viewBox="0 0 36.4 28.7"
              style="enable-background: new 0 0 36.4 28.7"
              xml:space="preserve"
            >
              <path
                d="M33.2,0H3.4C1.5,0,0,1.5,0,3.4v22c0,1.8,1.5,3.3,3.3,3.3h29.8c1.8,0,3.3-1.5,3.3-3.3v-22C36.6,1.5,35.1,0,33.2,0z M3.4,3
	h29.8c0.2,0,0.3,0.1,0.3,0.3v3.6l-15.2,8.9L3,6.9V3.4C3,3.2,3.2,3,3.4,3z M33.2,25.8H3.4c-0.2,0-0.3-0.2-0.3-0.3V10.4l14.5,8.4
	c0.2,0.1,0.5,0.2,0.8,0.2s0.5-0.1,0.8-0.2l14.4-8.4v15C33.6,25.6,33.4,25.8,33.2,25.8z"
              />
            </svg>
          </span>
          <input
            v-model="email"
            type="email"
            placeholder="Email"
            @keypress="handleEnter($event, 'email')"
            class="form-control login-email"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="col-2"></div>
    </div>
    <div class="row top-margin-fix">
      <div class="col-2"></div>
      <div class="col-8">
        <div class="input-group rel-input-group icon-padding">
          <span class="align-self-center">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              width="25"
              height="25"
              viewBox="0 0 60 69.5"
              style="enable-background: new 0 0 60 69.5"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M47,30.5c3.7,0,6,2.3,6,6v20c0,3.7-2.3,6-6,6H14c-3.9,0-7-2.6-7-6v-20c0-3.4,3.1-6,7-6H47 M47,23.5H14c-7.3,0-14,5.7-14,13
		v20c0,7.3,6.7,13,14,13h33c7.3,0,13-5.7,13-13v-20C60,29.2,54.3,23.5,47,23.5L47,23.5z"
                />
              </g>
              <g>
                <path
                  d="M50.3,19.5h-6.6c0-7.2-5.9-12.9-13.4-12.9c-7.4,0-12.9,5.5-12.9,12.9h-6.6C10.8,8.6,19.4,0,30.4,0
		C41.3,0,50.3,8.7,50.3,19.5z"
                />
              </g>
              <g>
                <rect x="26" y="42.5" width="7" height="14" />
              </g>
            </svg>
          </span>
          <!-- <input
          id="password"
          placeholder="Password"
          type="text"
          autocomplete="off"
          maxlength="8"
          inputmode="text"
          class="form-control input-big"
        />
        <input
          type="text"
          v-model="password"
          id="password_view"
          style="display: none"
          maxlength="8"
          inputmode="text"
          class="form-control input-big"
          placeholder="Password"
          readonly
        /> -->
          <input
            :type="password_type"
            v-model="password"
            maxlength="8"
            inputmode="text"
            class="form-control login-email"
            placeholder="Password"
            ref="password"
            @keypress="handleEnter($event, 'password')"
          />
          <div class="align-self-center">
            <a v-on:click="switchVisibility">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0 0 374 285.8"
                style="enable-background: new 0 0 374 285.8"
                xml:space="preserve"
                v-if="!eyeshow"
              >
                <g>
                  <g>
                    <g>
                      <path
                        d="M187,220.9c-43,0-77.8-34.9-77.8-77.8s34.9-77.8,77.8-77.8s77.8,34.9,77.8,77.8S230,220.9,187,220.9z M187,91.2
				c-28.7,0-51.9,23.2-51.9,51.9S158.3,195,187,195s51.9-23.2,51.9-51.9S215.7,91.2,187,91.2z"
                      />
                    </g>
                    <g>
                      <path
                        d="M187,285.8c-85.9-0.4-161.5-56.7-186.5-139c-0.6-2.5-0.6-5.1,0-7.5C31.1,36.3,139.4-22.5,242.4,8.1
				c63.1,18.7,112.5,68.1,131.2,131.2c0.6,2.5,0.6,5.1,0,7.5C348.6,229.1,273,285.4,187,285.8z M26.5,143.1
				c28.7,88.6,123.8,137.3,212.4,108.6c51.6-16.7,92-57.1,108.6-108.6C318.9,54.4,223.8,5.8,135.2,34.5
				C83.5,51.1,43.1,91.5,26.5,143.1z"
                      />
                    </g>
                    <g>
                      <path
                        d="M187,285.8c-85.9-0.4-161.5-56.7-186.5-139c-0.6-2.5-0.6-5.1,0-7.5C31.1,36.3,139.4-22.5,242.4,8.1
				c63.1,18.7,112.5,68.1,131.2,131.2c0.6,2.5,0.6,5.1,0,7.5C348.6,229.1,273,285.4,187,285.8z M26.5,143.1
				c28.7,88.6,123.8,137.3,212.4,108.6c51.6-16.7,92-57.1,108.6-108.6C318.9,54.4,223.8,5.8,135.2,34.5
				C83.5,51.1,43.1,91.5,26.5,143.1z"
                      />
                    </g>
                    <g>
                      <path
                        d="M58.5,284.5c-3.4,0-6.8-1.3-9.2-3.8c-5.1-5-5.1-13.3-0.1-18.3l0.1-0.1L306.3,5.4c5.1-5.1,13.3-5.1,18.4,0
				s5.1,13.3,0,18.4L67.8,280.7C65.3,283.2,61.9,284.5,58.5,284.5z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="20"
                height="20"
                viewBox="0 0 117.6 90.3"
                style="enable-background: new 0 0 117.6 90.3"
                xml:space="preserve"
                v-if="eyeshow"
              >
                <g>
                  <path
                    d="M58.8,20.5c13.5,0,24.5,11,24.5,24.5s-11,24.5-24.5,24.5S34.3,58.5,34.3,45S45.3,20.5,58.8,20.5z M58.8,61.3
		c9,0,16.3-7.3,16.3-16.3s-7.3-16.3-16.3-16.3S42.5,36,42.5,45S49.8,61.3,58.8,61.3z"
                  />
                  <path
                    d="M58.8,0c27,0,50.9,17.7,58.8,43.6v2.5c-9.6,32.4-43.3,51.2-76,41.6C21.7,81.9,5.9,66.1,0,46.2v-2.5C7.9,17.7,31.8,0,58.8,0
		z M109.5,45c-8.7-28.1-38.6-43.6-66.7-34.9C26.2,15.5,13.5,28.4,8.2,45c8.7,27.9,38.6,43.3,66.7,34.6
		C91.2,74.3,104.1,61.3,109.5,45z"
                  />
                  <path
                    d="M58.8,0c27,0,50.9,17.7,58.8,43.6v2.5c-9.6,32.4-43.3,51.2-76,41.6C21.7,81.9,5.9,66.1,0,46.2v-2.5C7.9,17.7,31.8,0,58.8,0
		z M109.5,45c-8.7-28.1-38.6-43.6-66.7-34.9C26.2,15.5,13.5,28.4,8.2,45c8.7,27.9,38.6,43.3,66.7,34.6
		C91.2,74.3,104.1,61.3,109.5,45z"
                  />
                </g>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="col-2"></div>
    </div>
    <div class="row top-margin-fix">
      <div class="col-2"></div>
      <div class="col-8">
        <button
          type="button"
          v-on:click="clicklogin"
          class="height-6 btn btn-black btn-shadow-btn-black btn-login"
        >
          <span class="font-sign-in"> Sign In</span>
        </button>
      </div>
      <div class="col-2"></div>
    </div>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8">
        <label
          @click="clickBack()"
          class="payment-pin-label sign-in-label float-left"
          >I'm a Cashier</label
        >
        <label class="payment-pin-label sign-in-label float-right"
         @click = "forgetPassword()" style="cursor: pointer;" >Forgot Password?</label
        >
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>

<script>
import api from "../../api/login.js";
import apiterminal from "../../api/setterminal.js";
/**
 * write a component's description
 * this componenet is used for login for store and Employee
 */
export default {
  name: "Login",
  /**
   * @description-phoneNumberColor=> verify the validation for email field
   * -pinColor=> verify the validation for pin/password field
   * -showEmail=> check for email should be shown or not
   *  -user_type=> check for user type ,that can be store_user or terminal_user
   * -passwordtitle=> this will 'password' for store user type and 'pin' for Employee type
   * @returns {any}
   */
  data() {
    let self = this;
    return {
      alphanumeric_reg: /^[a-zA-Z0-9]+$/,
      eyeshow: false,
      keyboadeType: "",
      inputlength: 50,
      emailtitle: "Email:",
      passwordtitle: "Password:",
      show: false,
      passwordtype: "password",
      showbuttontitle: "Show",
      password: "",
      email: "",
      phoneNumberColor: "",
      pinColor: "",
      showEmail: true,
      password_type: "password",
    };
  },
  /**
   * @description-this function is used for whenever the page is loaded, this will check if the user is store user or Employee,
   * if Employee login will not show email field otherwise it will show both

   */
  created() {},
  mounted() {
    var self = this;
    // var ysp = new YouShallPass("*", 500);
    // ysp.fixIE9();
    // document
    //   .querySelector("#password")
    //   .addEventListener("input", ysp.keyboardInputHandle.bind(ysp));
    // document.querySelector("#password").addEventListener("input", function () {
    //   console.log(ysp.realText);
    //   var temp_password = ysp.realText;
    //   self.password = temp_password;
    // });
  },
  /**
   * @description-this function is used to check for validation first then it the api call for login user
   */
  methods: {
    // switchVisibility() {
    //   var self = this;
    //   if (!self.eyeshow) {
    //     $("#password").hide();
    //     $("#password_view").show();
    //     self.eyeshow = true;
    //   } else {
    //     $("#password_view").hide();
    //     $("#password").show();
    //     self.eyeshow = false;
    //   }
    // },

    // handling enter event for the login form

    handleEnter(evt, element) {
      var self = this;
      evt = evt ? evt : window.event;
      if (evt.keyCode === 13) {
        if (element === "email") {
          self.$refs.password.focus();
        } else {
          self.clicklogin();
        }
      }
    }
    ,
    switchVisibility() {
      var self = this;
      if (self.password_type == "password") {
        self.password_type = "text";
        self.eyeshow = true;
      } else {
        self.password_type = "password";
        self.eyeshow = false;
      }
    },
    clickBack() {
      if (localStorage.getItem("unique_terminal_id") == null) {
        alert(
          "Please setup a terminal before trying to access cashier portal."
        );
        return false;
      } else {
        let self = this;
        var request = {
          terminal_unique_id: localStorage.getItem("unique_terminal_id"),
        };
        apiterminal
          .getTerminalDetails(request)
          .then((response) => {
            if (response.code == 200) {
              if (response.data.pos_employee_login == 1) {
                self.$root.$emit("show_admin_login", false);
                self.$root.$emit("showicon", "hamburger");
                self.$router.push("/transactionAmount").catch((err) => {});
                self.$root.$emit("show_sign_out", true);
              } else {
                self.$root.$emit("show_admin_login", true);
                localStorage.removeItem("token");
                localStorage.removeItem("login_response");
                localStorage.removeItem("login_user_type");
                localStorage.removeItem("terminal_login_response");
                localStorage.removeItem("view_user");
                localStorage.setItem("token", response.data.token);
                axios.defaults.headers.common["Authorization"] =
                  response.data.token;
                //emit the icon name to show at the top left of the header
                self.$root.$emit("showicon", "hamburger");
                localStorage.setItem("login_user_type", "Employee");
                localStorage.setItem(
                  "terminal_login_response",
                  JSON.stringify(response.data)
                );
                //redirecting to the transaction amount page
                self.$router.push("/transactionAmount").catch((err) => {});
                self.$root.$emit(
                  "user_type",
                  localStorage.getItem("login_user_type")
                );
              }
            } else {
              alert(response.message);
            }
          })
          .catch(function (error) {});
      }
    },
    clicklogin() {
      let self = this;
      if (self.email == "") {
        self.phoneNumberColor = "red";
        alert(RequiredField);
        // alert("test");
        return false;
      }
      //this use to check for validation for password
      if (self.password == "") {
        self.pinColor = "red";
        alert(RequiredField);
        return false;
      }
      if (!self.alphanumeric_reg.test(self.password)) {
        alert("Please enter a valid password.");
        return false;
      }
      var request = {
        user_type: "Store User",
        email: self.email,
        password: self.password,
        terminal_identification_number: localStorage.getItem(
          "unique_terminal_id"
        ),
      };

      self.phoneNumberColor = "";
      self.pinColor = "";
      api
        .loginUser(request)
        .then((response) => {
          if (response.code == "200") {
            localStorage.removeItem("token");
            localStorage.removeItem("login_response");
            localStorage.removeItem("login_user_type");
            localStorage.removeItem("terminal_login_response");
            localStorage.removeItem("view_user");
            self.phoneNumberColor = "";
            self.pinColor = "";
            localStorage.removeItem("token");
            localStorage.setItem("token", response.data.token);
            axios.defaults.headers.common["Authorization"] =
              response.data.token;
            if (localStorage.getItem("unique_terminal_id") != null) {
              self.fetchTerminal(response.data.token);
            }
            localStorage.setItem("login_user_type", "Store User");
            localStorage.setItem("store_user_type", response.data.role_name);
            self.$root.$emit(
              "user_type",
              localStorage.getItem("login_user_type")
            );
            self.$router.push("/terminals");
            //emit the icon name to show at the top left of the header
            self.$root.$emit("showicon", "hamburger");
            localStorage.setItem(
              "login_response",
              JSON.stringify(response.data)
            );
          } else {
            alert(response.message);
          }
        })
        .catch(function (error) {});
    },
    showHidePassword: function () {
      if (this.passwordtype == "text") {
        this.passwordtype = "password";
        this.showbuttontitle = "Show";
        this.show = false;
      } else {
        this.passwordtype = "text";
        this.showbuttontitle = "Hide";
        this.show = true;
      }
    },
    //fetches the current terminal details
    fetchTerminal(token) {
      let self = this;
      var request = {
        terminal_unique_id: localStorage.getItem("unique_terminal_id"),
      };

      apiterminal
        .getTerminalDetails(request)
        .then((response) => {
          if (response.code == 200) {
            self.$root.$emit("changeTerminalName", response.data.terminal_name);
            localStorage.setItem("terminal_name", response.data.terminal_name);
          } else {
            alert(response.message);
          }
        })
        .catch(function (error) {});
    },
    forgetPassword()
    {
       let self = this;
       self.$router.push("/password-forgot");
    }
  },
};
</script>

<style lang="scss">
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #000000 !important;
  font-family: "Open Sans" !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: normal !important;
  // letter-spacing: 0.5px !important;
  text-align: left !important;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #000000 !important;
  font-family: "Open Sans" !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: normal !important;
  // letter-spacing: 0.5px !important;
  text-align: left !important;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #000000 !important;
  font-family: "Open Sans" !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: normal !important;
  // letter-spacing: 0.5px !important;
  text-align: left !important;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #000000 !important;
  font-family: "Open Sans" !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: normal !important;
  // letter-spacing: 0.5px !important;
  text-align: left !important;
}
</style>
